import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type InvoiceVoidParams = {
  id: string;
};

export const invoiceVoidAtom = createMutationAtomFactory(
  'finance.invoiceVoid',
  (params: InvoiceVoidParams) => ({
    financeInvoiceVoid: {
      __args: {
        id: params.id,
      },
      id: true,
      documentNumber: true,
      status: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
